
export enum ChangePasswordFailureReason {
  None = 'None',
  NotAuthenticated = 'NotAuthenticated',
  UserNotFound = 'UserNotFound',
  NewPasswordMissing = 'NewPasswordMissing',
  NewPasswordRecentlyUsed = 'NewPasswordRecentlyUsed',
  CurrentPasswordIncorrect = 'CurrentPasswordIncorrect'
}

export const ChangePasswordErrorMessages: Record<ChangePasswordFailureReason, string> = {
  [ChangePasswordFailureReason.None]: '',
  [ChangePasswordFailureReason.NotAuthenticated]:
    'You are not authenticated. Please sign in and try again.',
  [ChangePasswordFailureReason.UserNotFound]:
    'We could not find your account.',
  [ChangePasswordFailureReason.NewPasswordMissing]:
    'The new password must be different from your current password.',
  [ChangePasswordFailureReason.NewPasswordRecentlyUsed]:
    'You have recently used this password. Please choose a different one.',
  [ChangePasswordFailureReason.CurrentPasswordIncorrect]:
    'The current password you entered is incorrect.'
};
